import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M6.25 11.25H4.75V12.75H6.25V11.25Z" fill="currentColor" stroke="none" />
		<Path d="M19.25 11.25H17.75V12.75H19.25V11.25Z" fill="currentColor" stroke="none" />
		<Path d="M10.755 14.5L13 12L10.755 9.5M4.75 11.25H6.25V12.75H4.75V11.25ZM17.75 11.25H19.25V12.75H17.75V11.25Z" vectorEffect="non-scaling-stroke" />
	</SVG>
);
